import Hidden from "@material-ui/core/Hidden";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Tooltip from "@material-ui/core/Tooltip";
import moment from "moment";
import policyglyph from "Assets/newicons/document/policy/glyph/policy-glyph-16px.svg";
import policyoutlined from "Assets/newicons/document/policy/outline/policy-outline-16px.svg";
import userIconGlyph from "Assets/newicons/user/user/glyph/user-glyph-16px.svg";
import userIconOutline from "Assets/newicons/user/user/outline/user-outline-16px.svg";
import get from "lodash/get";
import Grid from "@material-ui/core/Grid";
import React from "react";
import { FormattedMessage } from "react-intl";
import loader from "Assets/Gif/loader.gif";
import noDataImage from "Assets/Svg/asset_empty.svg";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import { instance } from "../../../../Actions/AxiosInstance";

const getCategoryOption = (strOption, intIntputTypeId) => {
  if (intIntputTypeId == 3) {
    return moment(strOption).format("DD-MM-YYYY");
  }
  return strOption;
};

class AssetTabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabId: 0,
      pageloading: true,
      employeeid: null,
      colleagueid: null,
      physicalAssets: [],
      digitalAssets: [],
      hideButton: false,
      limit: 10,
      offset: 0,
      assetsTabs: [
        {
          label: (
            <FormattedMessage
              id="TabPhysicalAssets"
              defaultMessage="Physical assets"
            />
          ),
          icon: <img src={userIconOutline} style={{ marginBottom: 0 ,marginRight:8}}></img>,
          id: 0,
          name: "physicalassets",
        },
        {
          label: (
            <FormattedMessage
              id="TabDigitalAssets"
              defaultMessage="Digital assets"
            />
          ),
          icon: <img src={policyoutlined} style={{ marginBottom: 0 ,marginRight:8}}></img>,
          id: 1,
          name: "digitalassets",
        },
      ],
    };

    this.getEmployeeAsset = this.getEmployeeAsset.bind(this);
    this.ViewAsset = this.ViewAsset.bind(this);
  }

  componentDidMount() {
    const { AuthenticationAction, SubscriptionData, permissions, match } =
      this.props;
    const employeeid = AuthenticationAction.IsFulfilled
      ? AuthenticationAction.login.employeeid
      : SubscriptionData.employeeid;

    const masterprofileid = get(
      AuthenticationAction,
      "login.masterprofileid",
      9,
    );
    const { colleagueid } = match.params;

    const hideButton = !(
      permissions.editable &&
      colleagueid &&
      colleagueid != employeeid
    )
      ? false
      : masterprofileid != 9
      ? true
      : false;
    this.setState({ employeeid, colleagueid, hideButton }, () => {
      this.getEmployeeAsset();
    });
  }

  getEmployeeAsset() {
    const { colleagueid, employeeid, limit, offset } = this.state;
    this.setState({
      pageloading: true,
    });

    instance
      .get(
        `asset/getemployeeasset/${
          colleagueid || employeeid
        }/${limit}/${offset}`,
      )
      .then((result) => {
        this.setState({
          arrAsset: result.data.result,
          physicalAssets:
            result.data.result &&
            result.data.result.filter((item) => item.assettypeid == 1),
          digitalAssets:
            result.data.result &&
            result.data.result.filter((item) => item.assettypeid == 2),
          pageloading: false,
        });
      })
      .catch((error) => {
        this.setState({ pageloading: false });
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  handleMenuChange(selectedId) {
    let { assetsTabs } = this.state;
    assetsTabs = assetsTabs.map((tab) => {
      if (tab.id == 0) {
        return {
          ...tab,
          icon:
            tab.id == selectedId ? (
              <img src={userIconGlyph} style={{ marginBottom: 0 ,marginRight:8}}></img>
            ) : (
              <img src={userIconOutline} style={{ marginBottom: 0 ,marginRight:8}}></img>
            ),
        };
      } else {
        return {
          ...tab,
          icon:
            tab.id == selectedId ? (
              <img src={policyglyph} style={{ marginBottom: 0 ,marginRight:8}}></img>
            ) : (
              <img src={policyoutlined} style={{ marginBottom: 0 ,marginRight:8}}></img>
            ),
        };
      }
    });
    this.setState({ tabId: selectedId, assetsTabs });
  }

  ViewAsset(intAssetTypeId) {
    const { arrAsset, physicalAssets, digitalAssets } = this.state;

    return (
      <div
        className="profile-data-view-page width97 thin-scroll margin-left-16"
        style={{ overflowY: "auto" }}
      >
        {/* <Grid container>
          {arrAsset
            && arrAsset.length > 0
            && arrAsset
              .filter((asset) => asset.assettypeid == intAssetTypeId)
              .map((objAsset) => (
                <Grid
                  container
                  className="margin-bottom-20"
                  style={{ borderBottom: "1px dashed #d9dadb" }}
                >
                  <Grid item xs={12} md={8}>
                    <div
                      className="small-blue margin-bottom-16"
                      style={{ fontWeight: 700 }}
                    >
                      <Tooltip
                        title={
                          objAsset.assetstatusid == 3
                            ? `Please visit "Request Center" and acknowledge the asset assigned to you.`
                            : objAsset.status
                        }
                        placement="bottom"
                      >
                        <div>
                          <span>{objAsset.assetname}</span>
                          <span
                            className=""
                            style={{
                              marginLeft: 16,
                              fontSize: 12,
                              padding: "2px 16px",
                              borderRadius: 20,
                              border:
                                objAsset.assetstatusid == 3
                                  ? "solid 1px #ddd"
                                  : "solid 1px #008985",
                              background:
                                objAsset.assetstatusid == 3
                                  ? "#f7f7f8"
                                  : "#dcf2f1",
                              color:
                                objAsset.assetstatusid == 3
                                  ? "#888"
                                  : "#008985",
                              height: 16,
                            }}
                          >
                            {objAsset.status}
                          </span>
                        </div>
                      </Tooltip>
                    </div>
                    <div
                      className="display-flex margin-bottom-16"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="width50">
                        <p
                          className="small-dark-secondary"
                          style={{ fontWeight: 700 }}
                        >
                          Asset category
                        </p>
                      </div>
                      <div className="width50">
                        <p
                          className="small-dark-secondary"
                          style={{ fontWeight: 400 }}
                        >
                          {objAsset.categoryname}
                        </p>
                      </div>
                    </div>
                    <div
                      className="display-flex margin-bottom-16"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="width50">
                        <p
                          className="small-dark-secondary "
                          style={{ fontWeight: 700 }}
                        >
                          Asset ID
                        </p>
                      </div>
                      <div className="width50">
                        <p
                          className="small-dark-secondary "
                          style={{ fontWeight: 400 }}
                        >
                          {objAsset.assetcode}
                        </p>
                      </div>
                    </div>
                    <div
                      className="display-flex margin-bottom-16"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="width50">
                        <p
                          className="small-dark-secondary "
                          style={{ fontWeight: 700 }}
                        >
                          Assignment date
                        </p>
                      </div>
                      <div className="width50">
                        <p
                          className="small-dark-secondary "
                          style={{ fontWeight: 400 }}
                        >
                          {moment(objAsset.effectivefrom).format("DD-MM-YYYY")}
                        </p>
                      </div>
                    </div>

                    <div
                      className="display-flex margin-bottom-16"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="width50">
                        <p
                          className="small-dark-secondary "
                          style={{ fontWeight: 700 }}
                        >
                          Warranty status
                        </p>
                      </div>
                      <div className="width50">
                        <p
                          className="small-dark-secondary "
                          style={{ fontWeight: 400 }}
                        >
                          {objAsset.isunderwarranty == null
                            ? "None"
                            : objAsset.isunderwarranty
                            ? "Under warranty"
                            : "No warranty"}
                        </p>
                      </div>
                    </div>
                    {objAsset.assetattribute
                      && objAsset.assetattribute.map(
                        (objAttribute) =>
                          objAttribute && (
                            <div
                              className="display-flex margin-bottom-16"
                              style={{ justifyContent: "space-between" }}
                            >
                              <div className="width50">
                                <p
                                  className="small-dark-secondary "
                                  style={{ fontWeight: 700 }}
                                >
                                  {objAttribute.attributename}
                                </p>
                              </div>
                              <div className="width50">
                                <p className="small-dark-secondary ">
                                  {objAttribute.assetattibuteoption
                                    .map((option) =>
                                      getCategoryOption(
                                        option.optionname || option.inputvalue,
                                      ))
                                    .join(", ")}
                                </p>
                              </div>
                            </div>
                          ),
                      )}
                  </Grid>
                </Grid>
              ))}
        </Grid> */}
        {intAssetTypeId == 1 && (
          <Grid container>
            {physicalAssets && physicalAssets.length > 0 ? (
              physicalAssets.map((objAsset) => (
                <Grid
                  container
                  className="margin-bottom-20"
                  style={{ borderBottom: "1px dashed #d9dadb" }}
                >
                  <Grid item xs={12} md={8}>
                    <div
                      className="small-blue margin-bottom-16"
                      style={{ fontWeight: 700 }}
                    >
                      <Tooltip
                        title={
                          objAsset.assetstatusid == 3
                            ? `Please visit "Request Center" and acknowledge the asset assigned to you.`
                            : objAsset.status
                        }
                        placement="bottom"
                      >
                        <div>
                          <span>{objAsset.assetname}</span>
                          <span
                            className=""
                            style={{
                              marginLeft: 16,
                              fontSize: 12,
                              padding: "2px 16px",
                              borderRadius: 20,
                              border:
                                objAsset.assetstatusid == 3
                                  ? "solid 1px #ddd"
                                  : "solid 1px #008985",
                              background:
                                objAsset.assetstatusid == 3
                                  ? "#f7f7f8"
                                  : "#dcf2f1",
                              color:
                                objAsset.assetstatusid == 3
                                  ? "#888"
                                  : "#008985",
                              height: 16,
                            }}
                          >
                            {objAsset.status}
                          </span>
                        </div>
                      </Tooltip>
                    </div>
                    <div
                      className="display-flex margin-bottom-16"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="width50">
                        <p
                          className="small-dark-secondary"
                          style={{ fontWeight: 700 }}
                        >
                          Asset category
                        </p>
                      </div>
                      <div className="width50">
                        <p
                          className="small-dark-secondary"
                          style={{ fontWeight: 400 }}
                        >
                          {objAsset.categoryname}
                        </p>
                      </div>
                    </div>
                    <div
                      className="display-flex margin-bottom-16"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="width50">
                        <p
                          className="small-dark-secondary "
                          style={{ fontWeight: 700 }}
                        >
                          Asset ID
                        </p>
                      </div>
                      <div className="width50">
                        <p
                          className="small-dark-secondary "
                          style={{ fontWeight: 400 }}
                        >
                          {objAsset.assetcode}
                        </p>
                      </div>
                    </div>
                    <div
                      className="display-flex margin-bottom-16"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="width50">
                        <p
                          className="small-dark-secondary "
                          style={{ fontWeight: 700 }}
                        >
                          Assignment date
                        </p>
                      </div>
                      <div className="width50">
                        <p
                          className="small-dark-secondary "
                          style={{ fontWeight: 400 }}
                        >
                          {moment(objAsset.effectivefrom).format("DD-MM-YYYY")}
                        </p>
                      </div>
                    </div>

                    <div
                      className="display-flex margin-bottom-16"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="width50">
                        <p
                          className="small-dark-secondary "
                          style={{ fontWeight: 700 }}
                        >
                          Warranty status
                        </p>
                      </div>
                      <div className="width50">
                        <p
                          className="small-dark-secondary "
                          style={{ fontWeight: 400 }}
                        >
                          {objAsset.isunderwarranty == null
                            ? "None"
                            : objAsset.isunderwarranty
                            ? "Yes"
                            : "No"}
                        </p>
                      </div>
                    </div>
                    {objAsset.assetattribute &&
                      objAsset.assetattribute.map(
                        (objAttribute) =>
                          objAttribute && (
                            <div
                              className="display-flex margin-bottom-16"
                              style={{ justifyContent: "space-between" }}
                            >
                              <div className="width50">
                                <p
                                  className="small-dark-secondary "
                                  style={{ fontWeight: 700 }}
                                >
                                  {objAttribute.attributename}
                                </p>
                              </div>
                              <div className="width50">
                                <p className="small-dark-secondary ">
                                  {objAttribute.assetattibuteoption
                                    .map((option) =>
                                      getCategoryOption(option.optionname || option.inputvalue, objAttribute.inputvaluetypeid),
                                    )
                                    .join(", ")}
                                </p>
                              </div>
                            </div>
                          ),
                      )}
                  </Grid>
                </Grid>
              ))
            ) : (
              <DefaultComp
                heading="No asset assigned yet"
                imageSrc={noDataImage}
              />
            )}
          </Grid>
        )}

        {intAssetTypeId == 2 && (
          <Grid container>
            {digitalAssets && digitalAssets.length > 0 ? (
              digitalAssets.map((objAsset) => (
                <Grid
                  container
                  className="margin-bottom-20"
                  style={{ borderBottom: "1px dashed #d9dadb" }}
                >
                  <Grid item xs={12} md={8}>
                    <div
                      className="small-blue margin-bottom-16"
                      style={{ fontWeight: 700 }}
                    >
                      <Tooltip
                        title={
                          objAsset.assetstatusid == 3
                            ? `Please visit "Request Center" and acknowledge the asset assigned to you.`
                            : objAsset.status
                        }
                        placement="bottom"
                      >
                        <div>
                          <span>{objAsset.assetname}</span>
                          <span
                            className=""
                            style={{
                              marginLeft: 16,
                              fontSize: 12,
                              padding: "2px 16px",
                              borderRadius: 20,
                              border:
                                objAsset.assetstatusid == 3
                                  ? "solid 1px #ddd"
                                  : "solid 1px #008985",
                              background:
                                objAsset.assetstatusid == 3
                                  ? "#f7f7f8"
                                  : "#dcf2f1",
                              color:
                                objAsset.assetstatusid == 3
                                  ? "#888"
                                  : "#008985",
                              height: 16,
                            }}
                          >
                            {objAsset.status}
                          </span>
                        </div>
                      </Tooltip>
                    </div>
                    <div
                      className="display-flex margin-bottom-16"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="width50">
                        <p
                          className="small-dark-secondary"
                          style={{ fontWeight: 700 }}
                        >
                          Asset category
                        </p>
                      </div>
                      <div className="width50">
                        <p
                          className="small-dark-secondary"
                          style={{ fontWeight: 400 }}
                        >
                          {objAsset.categoryname}
                        </p>
                      </div>
                    </div>
                    <div
                      className="display-flex margin-bottom-16"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="width50">
                        <p
                          className="small-dark-secondary "
                          style={{ fontWeight: 700 }}
                        >
                          Asset ID
                        </p>
                      </div>
                      <div className="width50">
                        <p
                          className="small-dark-secondary "
                          style={{ fontWeight: 400 }}
                        >
                          {objAsset.assetcode}
                        </p>
                      </div>
                    </div>
                    <div
                      className="display-flex margin-bottom-16"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="width50">
                        <p
                          className="small-dark-secondary "
                          style={{ fontWeight: 700 }}
                        >
                          Assignment date
                        </p>
                      </div>
                      <div className="width50">
                        <p
                          className="small-dark-secondary "
                          style={{ fontWeight: 400 }}
                        >
                          {moment(objAsset.effectivefrom).format("DD-MM-YYYY")}
                        </p>
                      </div>
                    </div>

                    <div
                      className="display-flex margin-bottom-16"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="width50">
                        <p
                          className="small-dark-secondary "
                          style={{ fontWeight: 700 }}
                        >
                          Warranty status
                        </p>
                      </div>
                      <div className="width50">
                        <p
                          className="small-dark-secondary "
                          style={{ fontWeight: 400 }}
                        >
                          {objAsset.isunderwarranty == null
                            ? "None"
                            : objAsset.isunderwarranty
                            ? "Yes"
                            : "No"}
                        </p>
                      </div>
                    </div>
                    {objAsset.assetattribute &&
                      objAsset.assetattribute.map(
                        (objAttribute) =>
                          objAttribute && (
                            <div
                              className="display-flex margin-bottom-16"
                              style={{ justifyContent: "space-between" }}
                            >
                              <div className="width50">
                                <p
                                  className="small-dark-secondary "
                                  style={{ fontWeight: 700 }}
                                >
                                  {objAttribute.attributename}
                                </p>
                              </div>
                              <div className="width50">
                                <p className="small-dark-secondary ">
                                  {objAttribute.assetattibuteoption
                                    .map((option) =>
                                      getCategoryOption(option.optionname || option.inputvalue, objAttribute.inputvaluetypeid),
                                    ).join(", ")}
                                </p>
                              </div>
                            </div>
                          ),
                      )}
                  </Grid>
                </Grid>
              ))
            ) : (
              <DefaultComp
                heading="No asset assigned yet"
                imageSrc={noDataImage}
              />
            )}
          </Grid>
        )}
      </div>
    );
  }

  render() {
    const { tabId } = this.state;
    return (
      <div
        className="vertical-tab-section"
        style={{
          display: "flex",
          overflowY: Hidden,
          paddingLeft: 0,
        }}
      >
        <VerticalTabs
          value={tabId}
          indicatorColor="primary"
          textColor="primary"
          className="right-border width250 cursurpointer"
        >
          {this.state.assetsTabs.map((tab) => (
            <MyTab
              label={tab.label}
              icon={tab.icon}
              onClick={() => this.handleMenuChange(tab.id)}
              className={
                tab.id == 1
                  ? " IdentityDocuments var-tab-heading"
                  : tab.id == 2
                  ? " OtherDocuments var-tab-heading"
                  : "var-tab-heading"
              }
            />
          ))}
        </VerticalTabs>
        <div
          style={{
            width: 5,
            height: 530,
            background: "#d3d3d3",
            position: "relative",
            left: -4,
            zIndex: -1,
          }}
        ></div>
        {this.state.pageloading ? (
          <img className="loader" src={loader} />
        ) : (
          this.ViewAsset(tabId + 1)
        )}
      </div>
    );
  }
}

const VerticalTabs = withStyles(() => ({
  flexContainer: {
    flexDirection: "column",
  },
  indicator: {
    display: "none",
  },
}))(Tabs);

const MyTab = withStyles(() => ({
  labelContainer: {
    padding: "6px 8px",
  },
  label: {
    color: "rgba(0, 0, 0, 0.87)",
  },
  icon: {
    display: "inline-black",
  },
}))(Tab);

export default AssetTabs;
